// Material 3 switch with its label in one clickable row (16dp gap, body-large label), for forms and dialogs.
// Props: checked, onChange, label
(function () {
  const { Box, Typography } = MaterialUI;

  function SwitchField({ checked, onChange, label, sx }) {
    const { Switch } = window.Components;
    return (
      <Box component="label" sx={[{ display: 'flex', alignItems: 'center', gap: 2, cursor: 'pointer', userSelect: 'none', width: 'fit-content' }, ...(Array.isArray(sx) ? sx : [sx])]}>
        <Switch checked={checked} onChange={onChange} inputProps={{ 'aria-label': typeof label === 'string' ? label : undefined }} />
        <Typography variant="body1" component="span">{label}</Typography>
      </Box>
    );
  }

  window.Components = window.Components || {};
  window.Components.SwitchField = SwitchField;
})();
